define( [
	"./arr"
], function( arr ) {
	return arr.slice;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/slice.js
 ** module id = 817
 ** module chunks = 2
 **/